var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"question-first-step"},_vm._l((_vm.preFiles),function(preFile){return _c('Box',_vm._g({key:preFile.md5,attrs:{"validate":true,"boxConfig":preFile}},_vm.$listeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }